import React from 'react';
import translation from '../../languages';
import useGrades from '../../hooks/use-grades';
import './classes-sequence-block.scss';

type ClassesSequenceBlockProps = TranslationProps & { material: Material };

const ClassesSequenceBlock = (props: ClassesSequenceBlockProps) => {
    const { material, t } = props;

    const { materialClassGrades } = material;
    const grades = useGrades({ materialClassGrades });
    const gradesLength = grades.length;

    return (
        <p className='m-classes tsc-body classes-sequence-block'>
            {materialClassGrades && materialClassGrades.length > 0 && (
                <span>{t('common.materialBlock.classes')}: </span>
            )}
            {grades.map((grade, index) => (
                <>
                    <span className='grade' key={grade}>
                        {grade}
                    </span>
                    {index < gradesLength - 1 && <span>, </span>}
                </>
            ))}
        </p>
    );
};

const translate = translation(['common']);

export default translate(ClassesSequenceBlock);
